import {Component} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {NgOptimizedImage} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {MatDialogClose, MatDialogContent, MatDialogActions} from '@angular/material/dialog';
import {MatMiniFabButton, MatButton} from '@angular/material/button';


@Component({
    selector: 'myupdates-personal-onboarding-dialog',
    templateUrl: './personal-onboarding-dialog.component.html',
    styleUrls: ['./personal-onboarding-dialog.component.scss'],
    imports: [MatMiniFabButton, MatDialogClose, MatIcon, MatDialogContent, NgOptimizedImage, MatDialogActions, MatButton, TranslatePipe]
})
export class PersonalOnboardingDialogComponent {
  readonly firstPage = 0;
  readonly secondPage = 1;
  readonly lastPage = 2;
  dialogPage = this.firstPage;

  onNextPage(): void {
    this.dialogPage++;
  }

  onPreviousPage(): void {
    this.dialogPage--;
  }

}
